import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { OrderFormData } from "@/components/screens/OrderFormPage/types";
import { PaymentDataTabMessages } from "@/messages/order-form-page/payment-data-tab.messages";

type Props = {
  messages: PaymentDataTabMessages;
};

export default function OrderComments({ messages }: Props) {
  const { values, errors, handleChange } = useFormikContext<OrderFormData>();
  const { characterLimitExceeded } = messages;

  const orderComments1 = values.orderComments1 || "";
  const helperText = orderComments1.length > 1000 ? characterLimitExceeded : errors.orderComments1;

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between">
          <MDTypography variant="h5" fontWeight="bold">
            {messages.groupOrderValueTitle}
          </MDTypography>
        </MDBox>

        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 12 }}>
              <FormField
                externalLabel
                variant="outlined"
                name="orderComments1"
                label={messages.orderComments1Label}
                value={orderComments1}
                onChange={handleChange}
                fullWidth
                rows={4}
                multiline
                error={!!errors.orderComments1 || orderComments1.length > 1000}
                helperText={helperText}
                disabled={values.disabledButton}
              />
              <MDTypography
                color={orderComments1.length > 1000 ? "error" : "inherit"}
                variant="button"
              >
                {orderComments1.length < 1000 && (
                  <span>
                    <strong>{1000 - orderComments1.length}</strong> {messages.charactersRemaining}
                  </span>
                )}
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}
